import IEndpoints from "@/module/main/model/applicationForm/IEndpoints";

export default class Endpoints implements IEndpoints
{
    approvedRedirect: string;
    notificationEndpoint: string;
    rejectedRedirect: string;
    isReturnUrl: string; // TODO: Refactor after completing the HcCheckbox component. Change type to boolean.
    callMeDatetime: Date;
    callMeEndpoint: string;
    sourceId: string;

    constructor(data: Partial<Endpoints> = {})
    {
        this.approvedRedirect = data.approvedRedirect || "";
        this.notificationEndpoint = data.notificationEndpoint || "";
        this.rejectedRedirect = data.rejectedRedirect || "";
        this.isReturnUrl = data.isReturnUrl || "true";
        this.callMeDatetime = data.callMeDatetime || new Date();
        this.callMeEndpoint = data.callMeEndpoint || "";
        this.sourceId = data.sourceId || "";
    }
}
